module.exports = __webpack_public_path__ + "assets/img/popup.d90e43af.png";